import { DatePipe } from '@angular/common';
import { EmpresaComponent } from './../company-view-detail/empresa/empresa.component';
import { Component, OnInit, ViewChild,Input,SimpleChanges } from '@angular/core';;
import { FlatTreeControl } from '@angular/cdk/tree';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { MatDialog } from '@angular/material/dialog';
import { CreateCompanyComponent } from './create-company/create-company.component';
import { CompanySideBarTreeViewService } from '../services/company-side-bar-tree-view.service';
import { SharedService } from 'app/modules/common/services/shared-service';
import { ConfirmDialogModel } from 'app/modules/common/components/confirmation-dialog/confirm-dialog-model';
import { ConfirmationDialogComponent } from 'app/modules/common/components/confirmation-dialog/confirmation-dialog.component';
import { MoveCompanyComponent } from './move-company/move-company.component';
import { PageLoaderService } from 'app/modules/common/services/page-loader.service'
import { CompanyManagementViewService } from '../services/company-management-view.service';
import Utils from 'app/Utils';
import { FileExportService } from 'app/modules/selection-generic/services/file-export.service';


interface CompanyNode {
  nombre: string;
  nivel: number;
  empresaId: number;
  activo: string;
  orden: string;
  padreId: number;
  finGestion : string;
  children?: CompanyNode[];

}
interface ExampleFlatNode {
  expandable: boolean;
  name: string;
  level: number;
}
@Component({
    selector: 'app-company-view-list',
    templateUrl: './company-view-list.component.html',
    styleUrls: ['./company-view-list.component.scss'],
    standalone: false
})
export class CompanyViewListComponent implements OnInit {
  @ViewChild(CreateCompanyComponent) child;
  @ViewChild(EmpresaComponent) appEmpresa: EmpresaComponent;
  @Input() loadTreeviewEmit:any;
  permissionList: Array<string>;
  currentUser: any[];
  currentUserAbreviacion: any;
  currentUserNombre: any;
  activeStatusTreeView: string = 'A';
  searchString: string = '';
  treeData;
  newCompanyPadreId;
  selectedPadreId;
  empresaId;
  empresaChildCount;
  selectedCompanyName;
  permit47: number;
  permit2: number;
  permit7: number;
  permit32: number;
  permit13: number;
  activeInactivePermission = false;
  crearPermission = false;
  activarPermission = false;
  desactivarPermission = false;
  moverPermission = false;
  cerrarBajasPermission = false;
  bloquearPermission = false;
  eliminarDatosPermission = false;
  eliminarEmpresaPermission = false;
  createdCompanyId;
  activeNode;
  boolIsCreated: boolean = false;
  myDateTime :string ;
  testString;
  private transformer = (node: CompanyNode, level: number) => {
    return {
      expandable: !!node.children && node.children.length > 0,
      name: node.nombre,
      id: node.empresaId,
      status: node.activo,
      padreid: node.padreId,
      level: level,
      finGestion:  this.datesCheck(this.datePipe.transform(node.finGestion, 'yyyy-MM-dd')),
    };
  }


  treeControl = new FlatTreeControl<ExampleFlatNode>(
    node => node.level, node => node.expandable);

  treeFlattener = new MatTreeFlattener(
    this.transformer, node => node.level, node => node.expandable, node => node.children);

  dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);
  
  constructor(
    
    private _dialog: MatDialog,
    private _companySideBarTreeViewService: CompanySideBarTreeViewService,
    private _companyManagementViewService : CompanyManagementViewService,
    private _sharedService: SharedService,
    private _pageLoaderService: PageLoaderService,
    private datePipe: DatePipe,
    private fileExportService: FileExportService

  ) {

  }

  datesCheck(finGestion)
  {
    this.myDateTime=new Date().toDateString();
    this.myDateTime = this.datePipe.transform(this.myDateTime, 'yyyy-MM-dd');
    if(finGestion==null)
    {
      return false;
    }
    else
    {
      if(this.datePipe.transform(finGestion, 'yyyy-MM-dd') < this.myDateTime)
      {
        return true;
      }
      else
      {
        return false;
      }
    }
  }
  hasChild = (_: number, node: ExampleFlatNode) => node.expandable;

  ngOnInit(): void {
    
    
    this.createdCompanyId = 0;
    this.GetTreeViewData(this.activeStatusTreeView, this.searchString);

    this.searchString = '';
    this.currentUser = JSON.parse(Utils.decrypt(localStorage.getItem('currentUser'))) ;
    this.currentUserAbreviacion = this.currentUser['abreviacion'];
    this.currentUserNombre = this.currentUser['nombre'];
    this.permissionList = Utils.decrypt(localStorage.getItem('permissionIds')).split(',');
    this.permit47 = this.permissionList.indexOf('47');
    this.permit2 = this.permissionList.indexOf('2');
    this.permit7 = this.permissionList.indexOf('7');
    this.permit32 = this.permissionList.indexOf('32');
    this.permit13 = this.permissionList.indexOf('13');

    if (this.permit47 != -1) {
      this.activeInactivePermission = true;
    }

    this._companySideBarTreeViewService.createdCompanyName.subscribe(message => this.createdCompanyId = message)


  }
  ngOnChanges(changes: SimpleChanges){
   /*  if(this.loadTreeviewEmit)
    {   
      // this._companySideBarTreeViewService.GetTreeView(this.activeStatusTreeView, this.searchString)
      // .subscribe(res => {
      //   this.treeData=res;
      //   this.dataSource.data = filterByEmpresa(this.treeData, this.loadTreeviewEmit.empresaId)
      //   this.treeControl.expandAll();
      // });
      this.GetTreeViewData(this.activeStatusTreeView, this.searchString);
      this.createdCompanyId=0;
    } */
    
  }

  nodeOperations(node) {
    
    //Set Crear Permission
    if (this.permit2 != -1 && node.status == "S") {
      this.crearPermission = true;
    }
    //Eliminar Company
    if (this.permit2 != -1 && node.status == "E") {
      this.crearPermission = false;
    }
    //Set Activar Permission
    if (this.permit7 != -1 && node.status == "N" && node.padreid != 0) {
      this.activarPermission = true;
      this.desactivarPermission = false;
    }
    //Set Desactivar Permission
    if (this.permit7 != -1 && node.status == "S" && node.padreid != 0) {
      this.desactivarPermission = true;
      this.activarPermission = false;
    }
    //Eliminar Company
    if (this.permit7 != -1 && node.status == "E" && node.padreid != 0) {
      this.desactivarPermission = true;
      this.activarPermission = false;
    }
    
    //Set Mover Permission
    if (this.permit32 != -1 && node.status == "S" && node.padreid != 0) {
      this.moverPermission = true;
    }else
    {
      this.moverPermission = false;
    }
    //Set Cerrar Bajas Permission
    if (this.permit13 != -1 && node.status == "S" && node.padreid != 0) {
      this.cerrarBajasPermission = true;
    }
    //Eliminar Company 
    if (this.permit13 != -1 && node.status == "E" && node.padreid != 0) {
      this.cerrarBajasPermission = true;
    }
    if(node.padreid == 0)
    {
      this.activarPermission = false;
      this.desactivarPermission = false;
      this.moverPermission = false;
      this.cerrarBajasPermission = false;
      this.bloquearPermission = false;
      this.eliminarDatosPermission = false;
      this.eliminarEmpresaPermission = false;
    }
    
    //Set Bloquar Permission,  Set Eliminar Datos Permission, Set Eliminar Empresa Permission,
    if (this.permit7 != -1 && node.padreid != 0) {
      this.bloquearPermission = true;
      this.eliminarDatosPermission = true;
      this.eliminarEmpresaPermission = true;
    }
    
    this.newCompanyPadreId = node.id;
    this.empresaId = node.id;
    this.selectedPadreId = node.padreId;
    this.GetChildCompanyCount(this.empresaId);
  }

  nodeOperationsLoadEmpresa(node) {
    //always request data for root company
    if(this._companySideBarTreeViewService.selectedCompany != node.id || node.id == 1)
    {    
      //emit clicked company data
      this._companyManagementViewService.clickedNewCompany$.next(node);   

      this._companySideBarTreeViewService.selectedCompany=node.id;
      this.selectedPadreId = node.padreId;
      this.selectedCompanyName = node.name;     ;
    }
  }

  ResetTree(node)
  {
    if(this.createdCompanyId>0 && node.padreid==0)
    {
      this.GetTreeViewData(this.activeStatusTreeView, this.searchString);
      this.createdCompanyId=0;
      this.nodeOperationsLoadEmpresa(node)
    } 
  }

  filterTree(searchString: any) {
    this.dataSource.data = this.treeData.filter(employee => employee.nombre.indexOf(searchString) !== -1);
    this.dataSource.data = filter(this.treeData, searchString)
  }

  activeStatusChange(activeStatusTreeView: string) {    
    this.searchString = '';
    this.createdCompanyId=0;
    this.GetTreeViewData(activeStatusTreeView, this.searchString);   
    this.restCompanyProccess();   
  }

  searchCompany(searchString) {    
    if (searchString) {
     this.dataSource.data = filter(this.treeData, searchString.trim().toUpperCase())
      this.treeControl.expandAll();
      this.restCompanyProccess();
    } else {
      this.GetTreeViewData(this.activeStatusTreeView, this.searchString);
      this.createdCompanyId=0;
      this.restCompanyProccess();
    }
  }
   
  restCompanyProccess() {
    if(this.loadTreeviewEmit)
    {
      this._companySideBarTreeViewService.changecreatedCompanyName('')
      this._companySideBarTreeViewService.changeCompanyEmpresaId('0')
      this._companySideBarTreeViewService.changeCompanyEmpresaName('')
      this._companySideBarTreeViewService.sendClickUpdateEvent();
    }
    
  }

  activarCompany() {
    this.ChangeCompanyStatusActivar(this.empresaId, 'S');
  }

  desactivarCompany() {
    this.ChangeCompanyStatusDesActivar(this.empresaId, 'N');
  }

  descargarWordNivel() {
    this.WordNivelEmpresas(this.empresaId);
  }

  cerrarBajasCompany() {
    this.CloseLeaves(this.empresaId);
  }

  bloquearTrabajadoresCompany() {
    this.LockEmployeesNotWorking(this.empresaId);
  }

  eliminarDatosCompany() {
    this.DeleteDataOfCompany(this.empresaId);
  }

  eliminarCompany() {
    this.DeleteCompany(this.empresaId);
  }

  public createcompany(): void {
    const dialogRef = this._dialog.open(CreateCompanyComponent, {
      data: { padreId: this.newCompanyPadreId },
    });
    dialogRef.afterClosed().subscribe(res => {
      if(res==1)
      {
        this.ngOnInit();
      }
    });
  }

  public movecompany(): void {
    const dialogRef = this._dialog.open(MoveCompanyComponent, {
      data: { empresaId: this.empresaId, padreId: this.selectedPadreId },
    });
    dialogRef.afterClosed().subscribe(res => {
      this.restCompanyProccess();
      this.ngOnInit();
    });
  }

  private WordNivelEmpresas(empresaid: any) {
        this._pageLoaderService.ShowPageLoader();
        this._companySideBarTreeViewService.WordNivelEmpresas(empresaid, this.activeStatusTreeView).
        subscribe(res => {
          if (res != null && res != undefined) {
            this.fileExportService.DownloadFile(res.result.file, res.result.fileName);
          }
          this._sharedService.ShowSnackBar('Generado con éxito', 'Okay', 2000);
        }, err => {
          console.error(err);
          this._sharedService.ShowSnackBar('Se produjo un error', 'Okay', 2000);
        })
    this._pageLoaderService.HidePageLoader();
  }

  private GetTreeViewData(activeStatus: string, searchString: any) {
    this._companySideBarTreeViewService.GetTreeView(activeStatus, searchString)
      .subscribe(res => {
        if(res[0].children.length != 0) {
          this.treeData = res;
          this.dataSource.data = this.treeData;
        }
        if (this.createdCompanyId > 0) {
          this.dataSource.data = filterByEmpresa(this.treeData, this.createdCompanyId);
          this.treeControl.expandAll();
          this._companySideBarTreeViewService.changeCompanyEmpresaId('0');
        } else {
          if(this.treeData == undefined){
            this.treeData = res;
            this.dataSource.data = this.treeData;
          }else{
            this.dataSource.data = this.treeData;         
          }      
        }
      });
}

  private GetChildCompanyCount(empresaid: any) {
    this._companySideBarTreeViewService.CheckCompanyChildren(empresaid)
      .subscribe(res => {
        if (res.result > 0) {
          this.empresaChildCount = res.result;
        }
        else {
          this.empresaChildCount = 0;
        }
      });
  }

  private ChangeCompanyStatusActivar(empresaid: any, status: any) {
    const dialogData = new ConfirmDialogModel('¿Activar?', '');
    const dialogRef = this._dialog.open(ConfirmationDialogComponent, {
      data: dialogData
    });

    dialogRef.afterClosed().subscribe(response => {
      if (response) {
        this._pageLoaderService.ShowPageLoader();
        this._companySideBarTreeViewService.UpdateCompanyStatus(empresaid, status).subscribe(result => {
          if (result.result > 0) {
            this._pageLoaderService.HidePageLoader();
            this._sharedService.ShowSnackBar('Empresa activada', 'Okay', 2000);
            this.ngOnInit();
          } else {
            this._pageLoaderService.HidePageLoader();
            this._sharedService.ShowSnackBar('Empresa Activar error', 'Okay', 2000);
            this.ngOnInit();
          }
        }, err => {
          console.error(err);
          this._pageLoaderService.HidePageLoader();
          this._sharedService.ShowSnackBar('API solicitud fallida', 'Okay', 2000);
        });
      }
    }
    )
    this._pageLoaderService.HidePageLoader();
  }

  private ChangeCompanyStatusDesActivar(empresaid: any, status: any) {
    const dialogData = new ConfirmDialogModel('Al desactivar una empresa no se mostrará en el árbol de empresas, ni se podrán consultar sus trabajadores ni sus bajas, pero se mantendrán sus datos por si se quiere volver a activar. ¿Desactivar la empresa?', '');
    const dialogRef = this._dialog.open(ConfirmationDialogComponent, {
      data: dialogData
    });
    dialogRef.afterClosed().subscribe(response => {
     
      if (response) {
        this._pageLoaderService.ShowPageLoader();
        this._companySideBarTreeViewService.UpdateCompanyStatus(empresaid, status).subscribe(result => {
          if (result.result > 0) {
            this._pageLoaderService.HidePageLoader();
            this._sharedService.ShowSnackBar('Empresa desactivada', 'Okay', 2000);
           
            this.ngOnInit();
          } else {
            this._pageLoaderService.HidePageLoader();
            this._sharedService.ShowSnackBar('Empresa desactivar error', 'Okay', 2000);
            this.ngOnInit();
          }
        }, err => {
          console.error(err);
          this._pageLoaderService.HidePageLoader();
          this._sharedService.ShowSnackBar('API solicitud fallida', 'Okay', 2000);
        });
      }
    }
    )
    this._pageLoaderService.HidePageLoader();
  }

  private CloseLeaves(empresaid: any) {
    const dialogData = new ConfirmDialogModel('Esta operación CERRARÁ TODAS LAS BAJAS de la empresa seleccionada, en cambio no cerrará las bajas de las empresas que contenga en niveles inferiores. ¿Desea continuar?', '');
    const dialogRef = this._dialog.open(ConfirmationDialogComponent, {
      data: dialogData
    });
    dialogRef.afterClosed().subscribe(response => {
      if (response) {
        this._pageLoaderService.ShowPageLoader();
        this._companySideBarTreeViewService.CloseLeaves(empresaid, this.currentUserAbreviacion, this.currentUserNombre).subscribe(result => {
          if (result.result >= 0) {
            this._pageLoaderService.HidePageLoader();
            this._sharedService.ShowSnackBar('Se han cerrado ' + result.result + ' bajas correctamente', 'Okay', 2000);
            this.ngOnInit();
          } else {
            this._pageLoaderService.HidePageLoader();
            this._sharedService.ShowSnackBar('Cerrar bajas error', 'Okay', 2000);
            this.ngOnInit();
          }
        }, err => {
          console.error(err);
          this._pageLoaderService.HidePageLoader();
          this._sharedService.ShowSnackBar('API solicitud fallida', 'Okay', 2000);
        });
      }
    }
    )
    this._pageLoaderService.HidePageLoader();
  }

  private LockEmployeesNotWorking(empresaid: any) {
    const dialogData = new ConfirmDialogModel('¿Marcar para bloquear todos los trabajadores de esta empresa y de las empresas dependientes que tengan fecha de fin de contrato establecida inferior a hoy?', '');
    const dialogRef = this._dialog.open(ConfirmationDialogComponent, {
      data: dialogData
    });
    dialogRef.afterClosed().subscribe(response => {
      if (response) {
        this._companySideBarTreeViewService.LockEmployeesNotWorking(empresaid).subscribe(result => {
          if (result.result >= 0) {
            this._sharedService.ShowSnackBar('Se han marcado ' + result.result + ' trabajadores. Por la noche se bloquearán', 'Okay', 2000);
            this.ngOnInit();
          } else {
            this._sharedService.ShowSnackBar('Bloquear trabajadores de baja de empresa error', 'Okay', 2000);
            this.ngOnInit();
          }
        }, err => {
          console.error(err);
          this._sharedService.ShowSnackBar('API solicitud fallida', 'Okay', 2000);
        });
      }
    }
    )
  }

  private DeleteDataOfCompany(empresaid: any) {
    const dialogData = new ConfirmDialogModel('Los datos propios de la empresa, los datos contables y el personal de contacto no se eliminarán. ¿Eliminar trabajadores, bajas, actuaciones, tareas, atributos, visitas de empresa y otras gestiones de esta empresa y todas sus delegaciones?', '');
    const dialogRef = this._dialog.open(ConfirmationDialogComponent, {
      data: dialogData
    });
    dialogRef.afterClosed().subscribe(response => {
      if (response) {
        this._pageLoaderService.ShowPageLoader();
        this._companySideBarTreeViewService.DeleteDataOfCompany(empresaid).subscribe(result => {
          if (result.result > 0) {
            this._pageLoaderService.HidePageLoader();
            this._sharedService.ShowSnackBar('Los datos de la empresa han sido eliminados. La empresa aparece como eliminada', 'Okay', 2000);
            this.GetTreeViewData(this.activeStatusTreeView, this.searchString);
            this._companySideBarTreeViewService.changeCompanyEmpresaId('0')
            this._companySideBarTreeViewService.changeCompanyEmpresaName('')
            this._companySideBarTreeViewService.sendClickUpdateEvent();
            this.createdCompanyId=0;
            this.restCompanyProccess();
          } else if (result.result == 0) {
            this._pageLoaderService.HidePageLoader();
            this._sharedService.ShowSnackBar('Esta empresa tiene gastos pendiete de facturar. No se pueden eliminar sus datos hasta que se cierre el mes', 'Okay', 2000);
            this.ngOnInit();
          }
          else {
            this._pageLoaderService.HidePageLoader();
            this._sharedService.ShowSnackBar('Eliminar datos error', 'Okay', 2000);
            this.ngOnInit();
          }
        }, err => {
          console.error(err);
          this._pageLoaderService.HidePageLoader();
          this._sharedService.ShowSnackBar('API solicitud fallida', 'Okay', 2000);
        });
      }
    }
    )
    this._pageLoaderService.HidePageLoader();
  }

  private DeleteCompany(empresaid: any) {
    if (this.empresaChildCount > 0) {
      const dialogData = new ConfirmDialogModel('ATENCIÓN: Esta empresa tiene niveles inferiores, los cuales también se van a eliminar. ¿Continuar?', '');
      const dialogRef = this._dialog.open(ConfirmationDialogComponent, {
        data: dialogData
      });
      dialogRef.afterClosed().subscribe(response => {
        if (response) {
          this.DeleteCompanyProccess(empresaid)
        }
      }
      )
    } else {
      const dialogData = new ConfirmDialogModel('Al eliminar la empresa, también se eliminarán todos sus trabajadores, bajas y visitas. ¿Continuar?', '');
      const dialogRef = this._dialog.open(ConfirmationDialogComponent, {
        data: dialogData
      });
      dialogRef.afterClosed().subscribe(response => {
        if (response) {
          this.DeleteCompanyProccess(empresaid);
        }
      }
      )
    }

  }

  private DeleteCompanyProccess(empresaid: any) {
    this._pageLoaderService.ShowPageLoader();
    this._companySideBarTreeViewService.DeleteCompany(empresaid).subscribe(result => {
      if (result.result == 0) {
        this._companySideBarTreeViewService.changeCompanyEmpresaId('0')
        this.ngOnInit();
        this._pageLoaderService.HidePageLoader();
        this._sharedService.ShowSnackBar('Esta empresa tiene datos contables y no se puede eliminar.', 'Okay', 2000);
      }
      else if (result.result > 0) {
        this._pageLoaderService.HidePageLoader();
        this.loadTreeviewEmit=1;
        this.restCompanyProccess();
        this.ngOnInit();
      }
      else {
        this._pageLoaderService.HidePageLoader();
        this._sharedService.ShowSnackBar('Eliminar datos error', 'Okay', 2000);
      }
    }, err => {
      console.error(err);
      this._pageLoaderService.HidePageLoader();
      this._sharedService.ShowSnackBar('API solicitud fallida', 'Okay', 2000);
    });
  }
}

function filter(array, text) {
  const getNodes = (result, object) => {
    if (object.nombre.match(text)) {
      result.push(object);
      return result;
    }
    if (Array.isArray(object.children)) {
      const children = object.children.reduce(getNodes, []);
      if (children.length) result.push({ ...object, children });
    }
    return result;
  };

  return array.reduce(getNodes, []);
}
function filterByEmpresa(array, text) {
  const getNodes = (result, object) => {
    if (object.empresaId === text) {
      result.push(object);
      return result;
    }
    if (Array.isArray(object.children)) {
      const children = object.children.reduce(getNodes, []);
      if (children.length) result.push({ ...object, children });
    }
    return result;
  };

  return array.reduce(getNodes, []);
}

